
import moment from "moment-timezone";
import { defineComponent } from "vue";
import { useToastStore } from "@/stores/toastStore";

export default defineComponent({
	name: "imdex-field-range",
	setup() {
		const toast = useToastStore();

		return {
			toast
		};
	},
	props: {
		isFixed: {
			type: Boolean,
			default: false
		},
		hideRange: {
			type: Boolean,
			default: false
		},
		isCategorical: {
			type: Boolean,
			default: false
		},

		disabled: {
			type: Boolean,
			default: false
		},
		fields: {
			type: Array,
			default: () => [] as any
		},
		value: {
			type: Object,
			default: () => ({ field: "", min: -1, max: 1 })
		},
		noBorder: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			moment,
			disableOnApply: false,
			field_type: "int",
			activeDatePicker: "min",
			m: 1,
			d: 1,
			y: 2020,
			uiValue: {
				field: this.value.field,
				min: this.value.min.toFixed(3),
				max: this.value.max.toFixed(3)
			},
			minDatePicker: false,
			maxDatePicker: false
		};
	},

	mounted() {
		this.updateFieldType();
		if (this.fields == null) return;
		for (let i = 0; i < this.fields.length; i++) {
			if ((this.fields[i] as any).is_default) {
				if (this.value.field == "") {
					this.updateField("field", (this.fields[i] as any).value);
					this.onApply();
				}
			}
		}
	},
	computed: {
		minVal: {
			get(): any {
				if (this.field_type == "date") {
					return moment(this.value.min * 1000).format("MM/DD/YYYY");
				} else {
					return this.uiValue.min;
				}
			},
			set(v: any) {
				this.uiValue.min = v;
				this.blurValue("min");
			}
		},
		maxVal: {
			get(): any {
				if (this.field_type == "date") {
					return moment(this.value.max * 1000).format("MM/DD/YYYY");
				} else {
					return this.uiValue.max;
				}
			},
			set(v: any) {
				this.uiValue.max = v;
				this.blurValue("max");
			}
		}
	},
	watch: {
		value(val: any): any {
			this.updateFieldType();
			this.uiValue = JSON.parse(JSON.stringify(val));
			// console.log(val);
			// console.log(this.uiValue);
			// let roundedVal = JSON.parse(JSON.stringify(val));
			// roundedVal.min = roundedVal.min.toFixed(3);
			// roundedVal.max = roundedVal.max.toFixed(3);

			//  // console.log(roundedVal);
			//  // console.log(this.uiValue);
			//   if(roundedVal.min != Number(this.uiValue.min)){
			//    // console.log('NOT SAME MIN')
			this.blurValue("min");
			//   }
			//   if(roundedVal.max != Number(this.uiValue.max)){
			//     //console.log('NOT SAME MAX');
			this.blurValue("max");
			//   }
		}
	},

	methods: {
		updateFieldType(): any {
			if (this.fields == null) return;
			const field: any =
				this.fields[this.fields.findIndex((item: any) => item.value == this.value.field)];
			if (field != null) {
				if (field.column != null) {
					if (field.column.indexOf("date") > -1) {
						this.field_type = "date";
					} else {
						this.field_type = "int";
					}
				}
			}
		},
		focusValue(type: any): any {
			if (type == "min") {
				this.minVal = this.value[type];
			} else {
				this.maxVal = this.value[type];
			}
		},
		updateField(key: any, val: any): any {
			this.$emit("selectField", val);
			const input = Object.assign({}, this.value, { [key]: val });
			this.$emit("update:value", input);
			this.$nextTick(this.onReset);
			this.disableOnApply = true;
		},
		onApply(): any {
			if (this.value.min > this.value.max) {
				this.toast.toast({
					title: this.$t("ssa.displayPane.fieldRange.toastMinValueError"),
					type: "warning",
					dismissable: false,
					message: ""
				});

				return;
			}

			//if (!this.disableOnApply) {
			this.$emit("update:change", {
				field: this.value.field,
				range: [parseFloat(this.value.min), parseFloat(this.value.max)]
			});
			//  }
			// this.disableOnApply = false;
		},
		onReset(): any {
			this.$emit("reset");
			//this.$nextTick(() => {});
		},
		async blurValue(type: any) {
			// console.log(this.value[type],Number(this.uiValue.min) )
			if (type == "min") {
				let minValueChange = Number(this.uiValue.min);

				if (this.value[type] != minValueChange) {
					if (minValueChange > this.uiValue.max) {
						this.toast.toast({
							title: this.$t("ssa.displayPane.fieldRange.toastMinValueError"),
							type: "warning",
							dismissable: false,
							message: ""
						});

						minValueChange = this.value[type];
					}

					this.$emit("update:value", {
						field: this.value.field,
						min: minValueChange,
						max: this.uiValue.max
					});
					this.$emit("change", {
						field: this.value.field,
						range: [minValueChange, this.uiValue.max]
					});
					return;
				}
				// this.minVal = JSON.parse(JSON.stringify(this.value[type]));
				// this.minVal = Number(this.minVal).toFixed(3);
			} else {
				let maxValueChange = Number(this.uiValue.max);

				if (this.value[type] != Number(this.uiValue.max)) {
					if (this.uiValue.min > maxValueChange) {
						this.toast.toast({
							title: this.$t("ssa.displayPane.fieldRange.toastMinValueError"),
							type: "warning",
							dismissable: false,
							message: ""
						});

						maxValueChange = this.value[type];
					}

					this.$emit("update:value", {
						field: this.value.field,
						min: Number(this.uiValue.min),
						max: maxValueChange
					});

					this.$emit("change", {
						field: this.value.field,
						range: [Number(this.uiValue.min), maxValueChange]
					});
					return;
				}
				// this.maxVal = JSON.parse(JSON.stringify(this.value[type]));
				// this.maxVal = Number(this.maxVal).toFixed(3);
			}
		}
	}
});
